import React from "react";
import "./brandStrip.css";
import Neo from "../../assets/images/neoteric.png"

// Using reliable SVG URLs that look good on white backgrounds
const BRANDS = [
//  {
//     name: "Google",
//     url: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_logo.svg"
//   },
  {
    name: "Nordic-Semiconductor",
    url: "https://www.nordicsemi.com/-/media/Images/Logos/Nordic-Semiconductor_logo.png"
  },
  {
    name: "Ework",
    url: "https://www.eworkgroup.com/hs-fs/hubfs/Ework%20-%20redesign/Images/Press%20and%20media/ework-press.jpg?width=600&name=ework-press.jpg"
  },
  {
    name: "Erricsson",
    url: "https://cdn.worldvectorlogo.com/logos/ericsson-1.svg"
  },
   {
    name: "H & M",
    url: "https://static.vecteezy.com/system/resources/previews/023/871/130/non_2x/hm-logo-brand-symbol-red-design-hennes-and-mauritz-clothes-fashion-illustration-with-black-background-free-vector.jpg"
  },
  {
    name: "Neoteric Technologies",
    url: Neo
  },
];


const BrandStrip: React.FC = () => {
  return (
    <section className="brand-strip" aria-label="Our clients">
      <div className="brand-strip-inner">

        <div
          className="brand-marquee"
          role="list"
          aria-live="off"
        >
          <div className="brand-track" aria-hidden="false">
            {/* First Set */}
            {BRANDS.map((brand, index) => (
              <div
                className="brand-item"
                role="listitem"
                key={index}
                style={{ ["--i" as any]: index }}
              >
                <img
                  src={brand.url}
                  alt={`${brand.name} logo`}
                  loading="lazy"
                  width={160}
                  height={48}
                />
              </div>
            ))}

            {/* Duplicate Set for Infinite Scroll */}
            {BRANDS.map((brand, index) => (
              <div
                className="brand-item"
                role="listitem"
                key={`dup-${index}`}
                style={{ ["--i" as any]: index + BRANDS.length }}
              >
                <img
                  src={brand.url}
                  alt={`${brand.name}  `}
                  loading="lazy"
                  width={160}
                  height={48}
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default BrandStrip;